import { render, staticRenderFns } from "./user-type-btn.vue?vue&type=template&id=51fcf87c"
import script from "./user-type-btn.vue?vue&type=script&lang=js"
export * from "./user-type-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports